import Vue from 'vue'
import App from './App.vue'

// import BootstrapVue from 'bootstrap-vue';
import * as VueGoogleMaps from 'vue2-google-maps';

import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css';

import router from './router/router.index';
import store from './store/store.index';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';

import './styles/main.css';
import './registerServiceWorker'
import {initDbStore} from "./indexedDb/initDb";

Vue.config.productionTip = false;

Vue.use(VueMaterial);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC9AWou0Owo5MLU80fnzcd1OpMG-8tXKl0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});

initDbStore();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

